import {PageTrackingContextProvider} from '@aboutyou/legacy-desktop/src/app/helpers/tracking/PageTrackingContext';
import {useTrackingPageUrl} from '@aboutyou/legacy-desktop/src/app/helpers/tracking/hooks/useTrackingPageUrl';
import LegacyPage from '@aboutyou/legacy-desktop/src/app/pages/Story/StoryPage';
import redialHandle from '@aboutyou/legacy-desktop/src/app/pages/Story/redial';
import {useStoryPageStore} from '@aboutyou/legacy-desktop/src/app/store/context';
import {TrackingPageTypeWithId} from '@aboutyou/legacy-tracking-sdk';
import {
  ANCHOR_OFFSET_FROM_STICKY_HEADER,
  DESKTOP_STICKY_HEIGHT,
  SPACER_BEFORE_STICKY_HEADER,
} from '@aboutyou/logic-components';
import {ScrollTopAnchor} from '@aboutyou/router';
import {useObserver} from 'mobx-react-lite';
import React from 'react';
import redial from 'redial';
import {useADPPreload} from '../../app/components/pages/ArticleDetailPage/useADPPreload';
import {withLegacyProviders} from '../LegacyComponentWrapper';

const TrackedStoryPage: React.FC = () => {
  const storyPageStore = useStoryPageStore();
  const {storyId, virtualCategoryId} = useObserver(() => {
    const {story, storyId} = storyPageStore;
    return {
      virtualCategoryId: story && Number(story.categoryId),
      storyId: (story && Number(story.id)) || Number(storyId),
    };
  });

  const {path, search} = useTrackingPageUrl();

  useADPPreload();

  return (
    <PageTrackingContextProvider
      id={Number(storyId)}
      path={path}
      search={search}
      virtualCategoryId={Number(virtualCategoryId) || undefined}
      type={TrackingPageTypeWithId.Story}
    >
      <LegacyPage
        ScrollTopAnchor={() => (
          <ScrollTopAnchor
            defaultOffsetTop={ANCHOR_OFFSET_FROM_STICKY_HEADER}
          />
        )}
        navigationStickyOffset={
          DESKTOP_STICKY_HEIGHT + SPACER_BEFORE_STICKY_HEADER
        }
      />
    </PageTrackingContextProvider>
  );
};

const PageWithRedial = redial.provideHooks(redialHandle)(TrackedStoryPage);

export const StoryPage = withLegacyProviders(PageWithRedial);
